import {
  gql,
} from '@apollo/client';

const GET_ADD_TO_BAG_NOTIFICATION_DATA = gql`
query FetchAddToBagNotificationData {
  freeShippingProgressInfo {
    isVisible
    amountToFreeShipping
    amountToFreeShippingFmt
    preLabel
    postLabel
    progressValue
    maxProgress
    minProgress
  }
}
`;

export default GET_ADD_TO_BAG_NOTIFICATION_DATA;
